import React from "react";
import { Card, CardBody, Row, Col, Badge, Button, Progress } from "reactstrap";
import {
  Mail,
  Phone,
  MapPin,
  Home,
  User,
  CheckCircle,
  ThumbsUp,
} from "react-feather";
import maleIcon from "../assets/profile/user.jpeg";
import { PRIMARY_TEXT_COLOR, PRIMARY_COLOR } from "../color";
import { useNavigate } from "react-router-dom";
import StepperComponent from "./StepperComponent"; // Import the StepperComponent

const UserProfile = ({ userData }) => {
  const history = useNavigate();
  const progress = 60; // Example progress value (replace with dynamic data if needed)
  const progressCondition=()=>{
    let res
    if(userData?.fld_profileflag==1){
      res= 60
    }
    if(userData?.fld_profileflag==1 && (userData?.fld_verifydoc ==1|| userData?.fld_verifydoc ==2)){
      res= 100
    }
    return res
  }
 
  return (
    <>
      <div className="py-4">
        {/* Stepper Section */}

        {/* Profile Header Section */}
        <Card
          className="border-0 mb-4"
          style={{ background: "linear-gradient(135deg, #c0c0c0, #a9a9a9)" }}
        >
          <CardBody className="text-white">
            <Row className="align-items-center">
              <Col xs="12" md="auto" className="text-center mb-4 mb-md-0">
                <div className="avatar avatar-xl mb-2">
                  <img
                    src={
                      process.env.REACT_APP_FILE_PATH_URL + userData.fld_photo
                    }
                    alt="Profile"
                    className="rounded-circle shadow-lg"
                    onError={(e) => (e.target.src = maleIcon)}
                    style={{
                      width: "120px",
                      height: "120px",
                      objectFit: "cover",
                      border: "4px solid white",
                    }}
                  />
                </div>
              </Col>
              <Col
                xs="12"
                md
                className="text-center text-md-start mb-4 mb-md-0"
              >
                {userData?.fld_usertype !== "Staff" ||
                userData?.fld_isadmin !== 1 ? (
                  <StepperComponent />
                ) : null}
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* Merged About Me and Contact Section */}
        <Row className="g-4">
          <Col xs="12" md="6">
            <Card className="border-0 shadow-sm h-100">
              <CardBody>
                <h2
                  style={{
                    color: PRIMARY_TEXT_COLOR,
                    fontSize: "1.25rem",
                    fontWeight: "600",
                  }}
                  className="d-flex align-items-center mb-4"
                >
                  {/* <User className="text-primary mr-2" size={20} /> */}
                  About Me
                </h2>

                {/* Name and Gender */}
                <div className="d-flex align-items-center mb-4">
                  <div className="rounded-circle bg-light bg-opacity-10 p-2 p-md-3 mr-1 mr-md-3">
                    <User
                      color={PRIMARY_COLOR}
                      size={20}
                      className="text-primary"
                    />
                  </div>
                  <div>
                    <p className="text-muted small mb-0">Name</p>
                    <p style={{ color: PRIMARY_TEXT_COLOR, textTransform:'capitalize' }} className="mb-0">
                      {userData?.fld_name || "N/A"}
                    </p>
                  </div>
                </div>

                <div className="d-flex align-items-center mb-4">
                  <div className="rounded-circle bg-light bg-opacity-10 p-2 p-md-3 mr-1 mr-md-3">
                    <ThumbsUp
                      color={PRIMARY_COLOR}
                      size={20}
                      className="text-primary"
                    />
                  </div>
                  <div>
                    <p className="text-muted small mb-0">Gender</p>
                    <p style={{ color: PRIMARY_TEXT_COLOR }} className="mb-0">
                      {userData?.fld_gender || "N/A"}
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="d-flex align-items-center mb-4">
                  <div className="rounded-circle bg-light bg-opacity-10 p-2 p-md-3 mr-1 mr-md-3">
                    <Mail
                      color={PRIMARY_COLOR}
                      size={20}
                      className="text-primary"
                    />
                  </div>
                  <div>
                    <p className="text-muted small mb-0">Email</p>
                    <p style={{ color: PRIMARY_TEXT_COLOR }} className="mb-0">
                      {userData?.fld_email || "N/A"}
                    </p>
                  </div>
                </div>

                {/* Phone */}
                <div className="d-flex align-items-center">
                  <div className="rounded-circle bg-light bg-opacity-10 p-2 p-md-3 mr-1 mr-md-3">
                    <Phone
                      color={PRIMARY_COLOR}
                      size={20}
                      className="text-primary"
                    />
                  </div>
                  <div>
                    <p className="text-muted small mb-0">Phone</p>
                    <p style={{ color: PRIMARY_TEXT_COLOR }} className="mb-0">
                      {userData?.fld_mobile || "N/A"}
                    </p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          {/* Combined Location Details and Profile Completion Section */}
          <Col xs="12" md="6">
            <Card className="border-0 shadow-sm mb-2">
              <CardBody>
                <h2
                  style={{
                    color: PRIMARY_TEXT_COLOR,
                    fontSize: "1.25rem",
                    fontWeight: "600",
                  }}
                  className="d-flex align-items-center mb-4"
                >
                  {/* <MapPin className="text-primary mr-2" size={20} /> */}
                  Location
                </h2>

                {/* Location Details */}
                <div className="d-flex align-items-center mb-4">
                  <div className="rounded-circle bg-light bg-opacity-10 p-2 p-md-3 mr-1 mr-md-3">
                    <MapPin
                      color={PRIMARY_COLOR}
                      size={20}
                      className="text-primary"
                    />
                  </div>
                  <div>
                    <p className="text-muted small mb-0">Region</p>
                    <p style={{ color: PRIMARY_TEXT_COLOR }} className="mb-0">
                      {userData?.fld_presentstate || "N/A"},{" "}
                      {userData?.fld_presentcity || "N/A"}
                    </p>
                  </div>
                </div>

                <div className="d-flex align-items-center mb-4">
                  <div className="rounded-circle bg-light bg-opacity-10 p-2 p-md-3 mr-1 mr-md-3">
                    <Home
                      color={PRIMARY_COLOR}
                      size={20}
                      className="text-primary"
                    />
                  </div>
                  <div>
                    <p className="text-muted small mb-0">Address</p>
                    <p style={{ color: PRIMARY_TEXT_COLOR }} className="mb-0">
                      {userData?.fld_presentaddress || "N/A"}
                    </p>
                  </div>
                </div>

                {/* Profile Completion */}
              </CardBody>
            </Card>
            {(userData?.fld_usertype !== "Staff" ||
              userData?.fld_isadmin !== 1) && (
              <Card className="border-0 shadow-sm ">
                <CardBody>
                  <div className="">
                    <h2
                      style={{
                        color: PRIMARY_TEXT_COLOR,
                        fontSize: "1.25rem",
                        fontWeight: "600",
                      }}
                      className="d-flex align-items-center mb-3"
                    >
                      <CheckCircle className="text-primary mr-2" size={20} />
                      Profile Completion
                    </h2>
                    <Progress
                      value={progressCondition()}
                      color={'success'}
                      style={{ height: "10px", borderRadius: "5px"}}
                    >
                      {progressCondition()}%
                    </Progress>
                    <p style={{ color: PRIMARY_TEXT_COLOR }} className="mt-2">
                      Complete your profile to unlock all features and improve
                      your experience.
                    </p>
                    {(userData?.fld_usertype !== "Staff" ||
                      userData?.fld_isadmin !== 1) && (
                      <div className="mt-4 text-center">
                        <Button
                          className=" btns"
                          style={{
                            textTransform: "capitalize",
                            fontWeight: "600",
                            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                            border: "none",
                            color: "#fff", // White text for contrast
                          }}
                          onClick={() => {
                            const id = encodeURIComponent(userData?.fld_id[0]);
                            history(`/edit/id=${id}`);
                          }}
                        >
                          <CheckCircle size={20} className="mr-2" />
                          {(userData?.fld_verifydoc == 0 || userData?.fld_verifydoc == null)
                            ? "Complete Your Profile"
                            : "Edit Profile"}
                        </Button>
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default UserProfile;
